function reviewCarouselModalStarSvg(filled) {
  const svgClass = filled ? 'bi-star bi-star-fill' : 'bi-star';
  return (
    '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1" class="' +
    svgClass +
    '" viewBox="0 0 16 16" aria-hidden="true">' +
    '<path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>' +
    '</svg>'
  );
}

if (!customElements.get('review-carousel-slider')) {
  class ReviewCarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.handleSectionLoad = this.handleSectionLoad.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
    }

    connectedCallback() {
      this.initWhenReady();
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', this.handleSectionLoad);
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (Shopify.designMode) {
        document.removeEventListener('shopify:section:load', this.handleSectionLoad);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
      }
    }

    handleSectionLoad(event) {
      const section = this.closest('.shopify-section');
      if (!section || event.detail.sectionId !== section.id.replace('shopify-section-', '')) return;
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      this.initWhenReady();
    }

    handleBlockSelect(event) {
      if (!this.contains(event.target)) return;
      const slide = event.target.closest('.swiper-slide');
      if (!slide || !this.swiper) return;
      const slides = Array.from(this.querySelectorAll('.swiper-slide'));
      const index = slides.indexOf(slide);
      if (index !== -1) this.swiper.slideTo(index);
    }

    initWhenReady() {
      if (typeof Swiper !== 'undefined') {
        this.initSlider();
        return;
      }
      const check = setInterval(() => {
        if (typeof Swiper !== 'undefined') {
          clearInterval(check);
          this.initSlider();
        }
      }, 50);
      setTimeout(() => clearInterval(check), 5000);
    }

    initSlider() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }

      const container = this.querySelector('.swiper');
      if (!container) return;

      const root = this.closest('review-carousel-section');
      const desktop = Math.min(5, Math.max(3, parseInt(root?.dataset.desktopSlides || '4', 10)));
      const mobile = Math.min(2, Math.max(1, parseInt(root?.dataset.mobileSlides || '1', 10)));
      const slideCount = container.querySelectorAll('.swiper-slide').length;
      const mobileSlidesPerView = slideCount > mobile ? mobile + 0.2 : mobile;
      const showNav = root?.dataset.showNav === 'true';

      const nextEl = showNav ? this.querySelector('.swiper-button-next') : null;
      const prevEl = showNav ? this.querySelector('.swiper-button-prev') : null;

      const nav =
        showNav && nextEl && prevEl
          ? {
              nextEl,
              prevEl,
            }
          : undefined;

      this.swiper = new Swiper(container, {
        slidesPerView: mobileSlidesPerView,
        spaceBetween: 16,
        watchOverflow: true,
        centerInsufficientSlides: true,
        navigation: nav,
        breakpoints: {
          750: {
            slidesPerView: desktop,
            spaceBetween: 24,
          },
        },
      });
    }
  }

  customElements.define('review-carousel-slider', ReviewCarouselSlider);
}

if (!customElements.get('review-carousel-section')) {
  class ReviewCarouselSection extends HTMLElement {
    constructor() {
      super();
      this.data = [];
      this.modalSwiper = null;
      this.handleCardClick = this.handleCardClick.bind(this);
      this.handleModalClosed = this.handleModalClosed.bind(this);
    }

    connectedCallback() {
      this.readJson();
      this.addEventListener('click', this.handleCardClick);
      document.body.addEventListener('modalClosed', this.handleModalClosed);
      if (Shopify.designMode) {
        this.handleSectionLoadBound = this.handleSectionLoad.bind(this);
        document.addEventListener('shopify:section:load', this.handleSectionLoadBound);
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleCardClick);
      document.body.removeEventListener('modalClosed', this.handleModalClosed);
      if (Shopify.designMode && this.handleSectionLoadBound) {
        document.removeEventListener('shopify:section:load', this.handleSectionLoadBound);
      }
      this.destroyModalSwiper();
    }

    handleSectionLoad(event) {
      const section = this.closest('.shopify-section');
      if (!section || event.detail.sectionId !== section.id.replace('shopify-section-', '')) return;
      this.readJson();
    }

    readJson() {
      const script = this.querySelector('.review-carousel__json');
      if (!script || !script.textContent.trim()) {
        this.data = [];
        return;
      }
      try {
        this.data = JSON.parse(script.textContent);
      } catch (e) {
        this.data = [];
      }
    }

    handleModalClosed() {
      this.destroyModalSwiper();
    }

    destroyModalSwiper() {
      if (this.modalSwiper) {
        this.modalSwiper.destroy(true, true);
        this.modalSwiper = null;
      }
    }

    handleCardClick(event) {
      const card = event.target.closest('.review-carousel__card');
      if (!card || !this.contains(card)) return;
      const blockId = card.dataset.blockId;
      if (!blockId) return;
      event.preventDefault();
      this.openModal(blockId, card);
    }

    renderModalStars(container, rating) {
      container.innerHTML = '';
      const r = Math.min(5, Math.max(0, parseInt(rating, 10) || 0));
      for (let i = 1; i <= 5; i++) {
        const filled = i <= r;
        const span = document.createElement('span');
        span.className = `review-carousel__star review-carousel__star--modal ${filled ? 'review-carousel__star--full' : 'review-carousel__star--empty'}`;
        span.innerHTML = reviewCarouselModalStarSvg(filled);
        container.appendChild(span);
      }
    }

    openModal(blockId, opener) {
      const entry = this.data.find((d) => String(d.id) === String(blockId));
      if (!entry) return;

      const modalEl = document.getElementById(`ReviewModal-${this.dataset.sectionId}`);
      if (!modalEl || typeof modalEl.show !== 'function') return;

      const starsEl = modalEl.querySelector('[data-modal-stars]');
      const avatarEl = modalEl.querySelector('[data-modal-avatar]');
      const nameEl = modalEl.querySelector('[data-modal-name]');
      const dateEl = modalEl.querySelector('[data-modal-date]');
      const textEl = modalEl.querySelector('[data-modal-text]');
      const verifiedEl = modalEl.querySelector('[data-modal-verified]');
      const productEl = modalEl.querySelector('[data-modal-product]');
      const slidesWrap = modalEl.querySelector('.review-carousel-modal__slides');
      const mediaCol = modalEl.querySelector('.review-carousel-modal__media');

      if (starsEl) this.renderModalStars(starsEl, entry.rating);

      const name = entry.reviewer_name || '';
      if (avatarEl) {
        const letter = name.trim().charAt(0).toUpperCase() || '?';
        avatarEl.textContent = letter;
      }
      if (nameEl) nameEl.textContent = name;

      if (dateEl) {
        if (entry.review_date) {
          dateEl.textContent = entry.review_date;
          dateEl.hidden = false;
        } else {
          dateEl.textContent = '';
          dateEl.hidden = true;
        }
      }

      if (textEl) {
        textEl.textContent = entry.review_text || '';
      }

      if (verifiedEl) {
        verifiedEl.hidden = !entry.show_verified;
      }

      if (productEl) {
        if (entry.product_url) {
          productEl.href = entry.product_url;
          productEl.textContent = entry.product_label || '';
          productEl.hidden = false;
        } else {
          productEl.removeAttribute('href');
          productEl.textContent = '';
          productEl.hidden = true;
        }
      }

      const urls = [entry.image_main, entry.image_gallery_1, entry.image_gallery_2].filter((u) => u && String(u).length > 0);

      if (slidesWrap) {
        if (urls.length === 0) {
          slidesWrap.innerHTML =
            '<div class="swiper-slide"><div class="review-carousel-modal__no-img" role="img" aria-label=""></div></div>';
        } else {
          slidesWrap.innerHTML = urls
            .map(
              (url, idx) =>
                `<div class="swiper-slide"><img src="${url}" alt="" loading="eager" fetchpriority="${idx === 0 ? 'high' : 'auto'}" width="1200" height="1600" decoding="async" /></div>`
            )
            .join('');
        }
      }

      if (mediaCol) {
        mediaCol.hidden = false;
      }

      this.destroyModalSwiper();

      const swiperEl = modalEl.querySelector('.review-carousel-modal__swiper');
      const paginationEl = modalEl.querySelector('.review-carousel-modal__pagination');
      const nextBtn = modalEl.querySelector('.review-carousel-modal__btn-next');
      const prevBtn = modalEl.querySelector('.review-carousel-modal__btn-prev');
      const count = Math.max(urls.length, 1);

      const hasMultiSlides = count > 1;
      const navigation =
        hasMultiSlides && nextBtn && prevBtn
          ? { nextEl: nextBtn, prevEl: prevBtn }
          : undefined;
      const pagination =
        hasMultiSlides && paginationEl
          ? { el: paginationEl, clickable: true }
          : undefined;

      modalEl.show(opener);

      const refreshModalSwiperLayout = () => {
        if (!this.modalSwiper) return;
        try {
          this.modalSwiper.updateSize();
          this.modalSwiper.updateSlides();
          this.modalSwiper.updateProgress();
          this.modalSwiper.update();
        } catch (e) {
          console.error('[review-carousel] Modal Swiper layout update failed', e);
        }
      };

      let modalSwiperAttempts = 0;
      const initModalSwiperAfterOpen = () => {
        modalSwiperAttempts += 1;
        if (typeof Swiper === 'undefined') {
          if (modalSwiperAttempts < 120) {
            setTimeout(initModalSwiperAfterOpen, 50);
          }
          return;
        }
        if (!swiperEl) return;

        try {
          this.modalSwiper = new Swiper(swiperEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            watchOverflow: true,
            rewind: hasMultiSlides,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            resizeObserver: true,
            navigation,
            pagination,
            on: {
              init() {
                refreshModalSwiperLayout();
              },
            },
          });
        } catch (e) {
          console.error('[review-carousel] Modal Swiper init failed', e);
          this.modalSwiper = null;
        }

        if (!this.modalSwiper) return;

        swiperEl.querySelectorAll('img').forEach((img) => {
          if (img.complete) return;
          img.addEventListener('load', () => refreshModalSwiperLayout(), { once: true });
        });

        requestAnimationFrame(() => {
          refreshModalSwiperLayout();
          requestAnimationFrame(() => refreshModalSwiperLayout());
        });
        setTimeout(() => refreshModalSwiperLayout(), 50);
        setTimeout(() => refreshModalSwiperLayout(), 320);

        const modalContent = modalEl.querySelector('.review-carousel-modal__content');
        if (modalContent) {
          const onTransitionEnd = (ev) => {
            if (ev.propertyName !== 'transform') return;
            modalContent.removeEventListener('transitionend', onTransitionEnd);
            refreshModalSwiperLayout();
          };
          modalContent.addEventListener('transitionend', onTransitionEnd);
        }
      };

      requestAnimationFrame(() => {
        requestAnimationFrame(initModalSwiperAfterOpen);
      });
    }
  }

  customElements.define('review-carousel-section', ReviewCarouselSection);
}
